import { db, FieldValue } from '@/utils/Firebase'
import { Device } from '@/utils/Capacitor'
import { App } from '@capacitor/app'

let cachedDeviceId = null

const fallbackDeviceId = () => {
    try {
        const stored = window.localStorage.getItem('builder.deviceId')
        if (stored) return stored
        const generated = `web-${Math.random().toString(36).slice(2)}-${Date.now()}`
        window.localStorage.setItem('builder.deviceId', generated)
        return generated
    } catch {
        return `web-${Date.now()}`
    }
}

export const getDeviceId = async () => {
    if (cachedDeviceId) return cachedDeviceId
    const fromOS = await Device.getId()
    cachedDeviceId = fromOS || fallbackDeviceId()
    return cachedDeviceId
}

const getAppVersion = async () => {
    try {
        const info = await App.getInfo()
        return info.version || null
    } catch {
        return null
    }
}

export const saveDeviceToken = async (uid, token) => {
    if (!uid || !token) return
    const deviceId = await getDeviceId()
    const info = await Device.getInfo().catch(() => ({}))
    const appVersion = await getAppVersion()

    await db.collection('users').doc(uid)
        .collection('devices').doc(deviceId)
        .set({
            token,
            platform: info.platform || 'web',
            model: info.model || null,
            osVersion: info.osVersion || null,
            appVersion,
            updatedAt: FieldValue.serverTimestamp(),
        }, { merge: true })
}

export const removeCurrentDevice = async (uid) => {
    if (!uid) return;
    const deviceId = await getDeviceId()
    try {
        await db.collection('users').doc(uid)
            .collection('devices').doc(deviceId)
            .delete()
    } catch (err) {
        console.log('removeCurrentDevice err', err && err.code, err && err.message)
    }
}
